import { type BudgetPeriodConstructor } from '@webapp/platform/finance'
import { type ExpenseBudgetPeriodApiModel } from '../api-models/ExpenseBudgetPeriodApiModel'

export const mapExpenseBudgetPeriodApiModel = (
  apiModel: ExpenseBudgetPeriodApiModel
): BudgetPeriodConstructor => ({
  startDate: apiModel.start_datetime,
  endDate: apiModel.end_datetime,
  expired: apiModel.expired,
})
